import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-board-settings-card-layout.services.rank-card-layout-field.title',
		defaultMessage: "We couldn't reorder your fields",
		description: 'Title for error flag for when reordering card layout fields fail',
	},
});
